// ✅ TOUS LES IMPORTS EN PREMIER
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

// ✅ PUIS LA CONFIGURATION
Amplify.configure(awsExports);

// ✅ PUIS LE CODE
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

